// extracted by mini-css-extract-plugin
module.exports = {"row":"EnrollClinic_row__19s9e"};